import React from 'react'

export function ArrowDownIcon (props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='icon--arrowDown'
      viewBox='0 0 32 32'
      width={24}
      height={24}
      {...props}
    >
      <path
        d='M15.9,23.1c-0.4,0-0.8-0.2-1.1-0.4L3.7,11.5c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l10.1,10.1L26,9.4c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1L17,22.6C16.7,22.9,16.3,23.1,15.9,23.1z'
      />
    </svg>
  )
}
